// Vendor imports
const { connect } = require('react-redux')
// Client V2 common imports
const deferDispatch = require('client-v2/common/state/dispatch')
// Entry imports
const { dismiss, openInApp } = require('./actions')
const OpenInAppButton = require('./component-dumb')
const { isVisibleState } = require('./selectors')

function mapStateToProps(state) {
  return {
    isVisible: isVisibleState(state)
  }
}

function mapDispatchToProps(dispatch) {
  const { dispatchAction } = deferDispatch(dispatch)
  return {
    onClick: dispatchAction(openInApp),
    onDismiss: dispatchAction(dismiss)
  }
}

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps
)(
  OpenInAppButton
)
